import contactModalWrapper from '../../../js/components/contactModal';
import coproModalWrapper from '../../../js/components/coproModal.js';

const modalWrapper = document.querySelectorAll('.contact-form-modal');
const CPmodalWrapper = document.querySelectorAll('.copro-form-modal');

const ContactFormModal = {

	registerClick: () => {
		modalWrapper.forEach(function (elm) {
			const contactInlineButton = elm.querySelector('.contact-inline-button');

			contactInlineButton.addEventListener('click', function (e) {
				e.preventDefault();
				contactModalWrapper.init();
				contactModalWrapper.handleOpen();

			});
		});
	},

	coproRegisterClick: () => {
		if (!CPmodalWrapper) return;
		CPmodalWrapper.forEach(function (elm) {
			const coproInlineButton = elm.querySelector('.copro-inline-button');

			coproInlineButton.addEventListener('click', function (e) {
				e.preventDefault();
				coproModalWrapper.init();
				coproModalWrapper.handleOpen();
			});
		});
	},

	init: () => {
		ContactFormModal.registerClick();
		ContactFormModal.coproRegisterClick();
	}

}

//export default ContactFormModal;
ContactFormModal.init();